<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="unlink-icon"
    aria-hidden="true"
  >
    <path
      d="M17.6161 23.5148C17.8876 23.7862 17.8876 24.2264 17.6161 24.4979L15.0281 27.0859C11.5949 30.5191 6.00858 30.5193 2.5751 27.0859C-0.858146 23.6526 -0.858146 18.0662 2.5751 14.633L5.16319 12.0449C5.43465 11.7734 5.87482 11.7734 6.14634 12.0449L8.44031 14.3389C8.71178 14.6103 8.71178 15.0505 8.44031 15.322L5.85222 17.9101C4.22597 19.5364 4.22597 22.1825 5.85222 23.8088C7.47847 25.4351 10.1247 25.4351 11.751 23.8088L14.3391 21.2208C14.6105 20.9493 15.0507 20.9493 15.3222 21.2208L17.6161 23.5148ZM14.3391 8.44007C14.6105 8.71154 15.0507 8.71154 15.3222 8.44007L17.9102 5.85204C19.5365 4.22562 22.1827 4.22573 23.8091 5.85204C25.4353 7.47835 25.4353 10.1245 23.8091 11.7508L21.221 14.3388C20.9495 14.6103 20.9495 15.0505 21.221 15.322L23.5149 17.6159C23.7864 17.8874 24.2266 17.8874 24.4981 17.6159L27.0862 15.0279C30.5195 11.5946 30.5195 6.00822 27.0862 2.57492C23.6528 -0.858329 18.0665 -0.858329 14.6332 2.57492L12.0452 5.16295C11.7737 5.43441 11.7737 5.87458 12.0452 6.1461L14.3391 8.44007ZM27.943 29.2537L29.2538 27.9429C29.7968 27.3999 29.7968 26.5195 29.2538 25.9766L3.68449 0.407182C3.1415 -0.135809 2.26117 -0.135809 1.71824 0.407182L0.407365 1.71805C-0.135626 2.26105 -0.135626 3.14137 0.407365 3.68431L25.9767 29.2537C26.5197 29.7966 27.4 29.7966 27.943 29.2537Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup>
defineProps({
  size: {
    type: [String, Number],
    default: 30,
  },
})
</script>

<style scoped>
.unlink-icon {
  display: inline-block;
  vertical-align: middle;
}
</style>
